import React from 'react'
//MATERIAL UI CARD
import { Card, CardContent } from "@material-ui/core";

const MesaAyuda = () => {
    return (
        <div className="d-flex flex-column align-items-center mt-4 mb-4">
            <Card className="col-10 col-md-8 col-sm-9 col-xl-6" style={{ backgroundColor: '#ffa8005e' }}>
                <CardContent>
                    <div>
                        <h6>Ante cualquier inconveniente, no dude en llamarnos.</h6>
                        <p>
                            <b>Mesa de ayuda al teléfono: </b>
                            <b>(0379) - </b>
                            <b><a href="tel:+54-379-446-9755" target="_blank" without="true" rel="noopener noreferrer">4469755</a> - </b>
                            <b><a href="tel:+54-379-446-4558" target="_blank" without="true" rel="noopener noreferrer">4464558</a> - </b>
                            <b><a href="tel:+54-379-442-8990" target="_blank" without="true" rel="noopener noreferrer">4428990</a> / </b>
                            <b><a href="tel:0800-888-2790" target="_blank" without="true" rel="noopener noreferrer">0800-888-2790</a></b>
                        </p>
                        <p>
                            <b>WhatsApp: </b>
                            <b><a href="http://api.whatsapp.com/send?phone=5493794295989" target="_blank" without="true" rel="noopener noreferrer">+54 9 379 450-4093</a> / </b>
                            <b><a href="http://api.whatsapp.com/send?phone=5493794295953" target="_blank" without="true" rel="noopener noreferrer">+54 9 379 484-6860</a> / </b>
                            <b><a href="http://api.whatsapp.com/send?phone=5493794807006" target="_blank" without="true" rel="noopener noreferrer">+54 9 379 424-5444</a></b>
                        </p>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}

export default MesaAyuda;